import { Button, Input, Modal, Select, Upload } from 'antd'
import React, { useEffect, useState } from 'react'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { getUserId } from '../../../helpers/auth'
import { toast } from 'react-toastify'
import Loader from '../../../pages/pages/loader'
import {
  useCreateCampaignTypeMutation,
  useUpdateCampaignTypeMutation
} from '../../../redux/apis/campaignsManagement/types/cMTypesApiSlice'

const EditCreateCampaignTypeModal = ({
  type,
  open,
  setOpen,
  isEdit = false,
  setHolder,
  setIsEdit
}) => {
  const [create, { isLoading, isSuccess, error }] =
    useCreateCampaignTypeMutation()
  const [
    update,
    { isLoading: updateLoading, isSuccess: updateSuccess, error: updateError }
  ] = useUpdateCampaignTypeMutation()

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      description: type?.description || '',
      is_active: isEdit ? type?.is_active ? true : false : true,
      type: type?.type || '',
      last_updated_by_id: getUserId()
    },

    validationSchema: Yup.object({
      description: Yup.string().required('Please Enter Type Description'),
      is_active: Yup.boolean().required('Please Select Type Status'),
      type: Yup.string().required(
        'Please Enter Campaign type'
      )
    }),

    onSubmit: async values => {
      console.log(values)
      try {
        if (isEdit) {
          await update({ id: type?.id, body: values }).unwrap()
        } else {
          await create(values)
        }
      } catch (error) {
        console.error(error)
      }
    }
  })

  useEffect(() => {
    if (error?.data) {
      const errorMessages = Object.values(error.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    } else if (updateError?.data) {
      const errorMessages = Object.values(updateError.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [error, updateError])

  useEffect(() => {
    if (isSuccess) {
      toast.success('Campaign Type Added!')
      setOpen(false)
      validation.resetForm()
    } else if (updateSuccess) {
      toast.success('Campaign Type Updated!')
      setOpen(false)
      validation.resetForm()
    }
  }, [isSuccess, updateSuccess])
  return (
    <>
      <Loader isLoading={isLoading || updateLoading} />
      <div className='flex w-full justify-end'>
        <button
          className='btn btn-outline-theme mb-4'
          onClick={() => {
            setHolder()
            setIsEdit(false)
            setOpen(true)
          }}
        >
          Create New Campaign Type
        </button>
      </div>
      <Modal
        open={open}
        title={isEdit ? 'Edit Campaign Type' : 'Create New Campaign Type'}
        onCancel={() => setOpen(false)}
        footer={[
          <Button key='back' onClick={() => setOpen(false)}>
            Cancel
          </Button>,
          <Button
            key='submit'
            type='primary'
            onClick={() => {
              if (Object.keys(validation.errors).length !== 0) {
                Object.keys(validation.errors).map(key => {
                  toast.error(validation.errors[key]);
                })
                return
              }
              validation.handleSubmit()
            }}
          >
            Submit
          </Button>
        ]}
      >
        <div className='gap-8 '>
          <div className=' mb-3 flex-1'>
            <label>Campaign Type Status</label>
            <br />
            <Select
              className={''}
              name='is_active'
              style={{
                width: '100%'
              }}
              defaultValue={validation?.values?.is_active}
              value={validation?.values?.is_active}
              onChange={e => validation.setFieldValue('is_active', e)}
              onBlur={validation.handleBlur}
              options={[
                {
                  label: 'Active',
                  value: true
                },
                {
                  label: 'Inactive',
                  value: false
                }
              ]}
            />
            {validation.touched.status && validation.errors.status ? (
              <p className='text-danger'>{validation.errors.status}</p>
            ) : null}
          </div>

          <div className=' mb-3 flex-1'>
            <label className="form-label">Campaign Type</label>
            <Input
              type='text'
              name='type'
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.type}
            />
            {validation.touched.type && validation.errors.type ? (
              <p className='text-danger'>{validation.errors.type}</p>
            ) : null}
          </div>
          <div className=' mb-3 flex-1'>
            <label className="form-label">Description</label>
            <Input
              type='text'
              name='description'
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.description}
            />
            {validation.touched.description && validation.errors.description ? (
              <p className='text-danger'>{validation.errors.description}</p>
            ) : null}
          </div>
        </div>
      </Modal>
    </>
  )
}

export default EditCreateCampaignTypeModal
